import img11 from '../../../images/avs-video-maker/power1-1.png'
import img11x2 from '../../../images/avs-video-maker/power1-1@2x.png'
import img12 from '../../../images/avs-video-maker/power1-2.png'
import img12x2 from '../../../images/avs-video-maker/power1-2@2x.png'
import img13 from '../../../images/avs-video-maker/power1-3.png'
import img13x2 from '../../../images/avs-video-maker/power1-3@2x.png'

import img21 from '../../../images/avs-video-maker/power2-1.png'
import img21x2 from '../../../images/avs-video-maker/power2-1@2x.png'
import img22 from '../../../images/avs-video-maker/power2-2.png'
import img22x2 from '../../../images/avs-video-maker/power2-2@2x.png'
import img23 from '../../../images/avs-video-maker/power2-3.png'
import img23x2 from '../../../images/avs-video-maker/power2-3@2x.png'

import img31 from '../../../images/avs-video-maker/power3-1.png'
import img31x2 from '../../../images/avs-video-maker/power3-1@2x.png'
import img32 from '../../../images/avs-video-maker/power3-2.png'
import img32x2 from '../../../images/avs-video-maker/power3-2@2x.png'
import img33 from '../../../images/avs-video-maker/power3-3.png'
import img33x2 from '../../../images/avs-video-maker/power3-3@2x.png'

import img41 from '../../../images/avs-video-maker/power4-1.png'
import img41x2 from '../../../images/avs-video-maker/power4-1@2x.png'
import img42 from '../../../images/avs-video-maker/power4-2.png'
import img42x2 from '../../../images/avs-video-maker/power4-2@2x.png'
import img43 from '../../../images/avs-video-maker/power4-3.png'
import img43x2 from '../../../images/avs-video-maker/power4-3@2x.png'

const powers = [
    {
        id: 1,
        title: "Video Editor",
        desc:
            `Edit your raw footage effortlessly. Cut, trim, adjust aspect ratio, rotate videos filmed upside down, crop black borders, etc.`,
        img: [
            {
                id: '1.1',
                md: img11,
                lg: img11x2
            },
            {
                id: '1.2',
                md: img12,
                lg: img12x2
            },
            {
                id: '1.3',
                md: img13,
                lg: img13x2
            },
        ]
    },
    {
        id: 2,
        title: "Movie Maker",
        desc:
            `Create professional-looking videos for business, education, special events, and social media platforms with great efficiency.`,
        img: [
            {
                id: '2.1',
                md: img21,
                lg: img21x2
            },
            {
                id: '2.2',
                md: img22,
                lg: img22x2
            },
            {
                id: '2.3',
                md: img23,
                lg: img23x2
            },
        ]
    },
    {
        id: 3,
        title: "Screen Recorder",
        desc:
            `Capture your screen and record meetings, video calls, tutorials, demos and presentations.`,
        img: [
            {
                id: '3.1',
                md: img31,
                lg: img31x2
            },
            {
                id: '3.2',
                md: img32,
                lg: img32x2
            },
            {
                id: '3.3',
                md: img33,
                lg: img33x2
            },
        ]
    },
    {
        id: 4,
        title: "Slideshow Maker",
        desc:
            `Combine as many photos as you want into an impressive slideshow with music.`,
        img: [
            {
                id: '4.1',
                md: img41,
                lg: img41x2
            },
            {
                id: '4.2',
                md: img42,
                lg: img42x2
            },
            {
                id: '4.3',
                md: img43,
                lg: img43x2
            },
        ]
    },
]

export default powers
